<template>
  <div>
    {{ $t('audiences.audiencesPage') }}
  </div>
</template>

<script>
export default {
  created() {
    this.hideLoading()
  },
}
</script>

<style>

</style>
